import { Box, Stack } from '@mui/joy';
import { ReactNode } from 'react';

import { PageLayout } from 'core/components';
import { Direction } from 'theme/enums';

import { LeftMenu } from './LeftMenu';

interface IProps {
  children?: ReactNode;
  title?: string;
}

export const CompanySettingsLayout = ({ children, title }: IProps) => {
  return (
    <PageLayout title={title}>
      <Stack direction={Direction.ROW} sx={{ gap: 1, height: '100%' }}>
        <Box sx={{ flexShrink: 0, height: '100%', overflowY: 'auto' }}>
          <LeftMenu />
        </Box>
        <Box sx={{ flexGrow: 1, height: '100%' }}>{children}</Box>
      </Stack>
    </PageLayout>
  );
};
